import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ReservationDetail } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class ReservationEventService implements OnDestroy {
  private reservationsNeedRefreshEvent: Subject<boolean> = new Subject<boolean>();
  private reservationUpdatedEvent: Subject<ReservationDetail> = new Subject<ReservationDetail>();
  private reservationCancelledEvent: Subject<ReservationDetail> = new Subject<ReservationDetail>();
  private reservationStatusUpdatedEvent: Subject<ReservationDetail> = new Subject<ReservationDetail>();

  constructor() {}

  ngOnDestroy() {
    this.reservationsNeedRefreshEvent.complete();
    this.reservationUpdatedEvent.complete();
    this.reservationCancelledEvent.complete();
  }

  get reservationsNeedRefreshEvents(): Observable<boolean> {
    return this.reservationsNeedRefreshEvent.asObservable();
  }

  get reservationUpdatedEvents(): Observable<ReservationDetail> {
    return this.reservationUpdatedEvent.asObservable();
  }

  get reservationCancelledEvents(): Observable<ReservationDetail> {
    return this.reservationCancelledEvent.asObservable();
  }

  get reservationStatusUpdatedEvents(): Observable<ReservationDetail> {
    return this.reservationStatusUpdatedEvent.asObservable();
  }

  sendReservationsNeedRefreshEvent() {
    this.reservationsNeedRefreshEvent.next(true);
  }

  sendReservationUpdatedEvent(reservation: ReservationDetail) {
    this.reservationUpdatedEvent.next(reservation);
  }

  sendReservationCancelledEvent(reservation: ReservationDetail) {
    this.reservationCancelledEvent.next(reservation);
  }

  sendReservationStatusUpdatedEvent(reservationStatusUpdate: ReservationDetail) {
    this.reservationStatusUpdatedEvent.next(reservationStatusUpdate);
  }
}
